import React, { useEffect, useState } from 'react';
import leftArrow from '../../../../images/leftArrowNav.png';
import rightArrow from '../../../../images/rightArrowNav.png';

export const useNavControls = (navRef, menuRef, nodes) => {
    const [hasOverflowLeft, setHasOverflowLeft] = useState(false);
    const [hasOverflowRight, setHasOverflowRight] = useState(false);

    const scrollLeft = (e) => {
        e.stopPropagation();
        e.preventDefault()
        if (navRef.current) {
            navRef.current.scrollLeft -= 200;
        }
    };

    const scrollRight = (e) => {
        e.stopPropagation();
        e.preventDefault()
        if (navRef.current) {
            navRef.current.scrollLeft += 200;
        }
    };

    const updateOverflowState = () => {
        if (navRef.current) {
            const hasLeft = navRef.current.scrollLeft > 0;
            const hasRight =
                Math.ceil(navRef.current.scrollLeft) <
                navRef.current.scrollWidth - navRef.current.clientWidth;

            setHasOverflowLeft(hasLeft);
            setHasOverflowRight(hasRight);
        }
    };

    useEffect(
        () => {
            const handleScroll = () => {
                updateOverflowState();
            };
            const node = navRef.current;
            if (node) {
                node.addEventListener('scroll', handleScroll);
            }
            return () => {
                if (node) {
                    node.removeEventListener('scroll', handleScroll);
                }
            };
        },
        [nodes],
    );

    useEffect(
        () => {
            if (navRef.current) {
                const BUTTON_WIDTH = 96;
                const totalContentWidth = Array.from(navRef.current.childNodes).reduce(
                    (total, child) => {

                        return total + child.offsetWidth;
                    },
                    0,
                );


                const hasLeft = navRef.current.scrollLeft > 0;
                const hasRight =
                    (totalContentWidth > navRef.current.clientWidth + BUTTON_WIDTH);

                setHasOverflowLeft(hasLeft);
                setHasOverflowRight(hasRight);
            }
        },
        [nodes, navRef?.current?.scrollWidth, navRef?.current?.clientWidth],
    );

    useEffect(() => {
        const disableWheelScroll = e => {
            e.preventDefault();
        };
        const container = navRef.current;
        if (container) {
            container.addEventListener('wheel', disableWheelScroll, {
                passive: false,
            });
        }
        return () => {
            if (container) {
                container.removeEventListener('wheel', disableWheelScroll);
            }
        };
    }, []);

    const LetfButton = () => {

        return (
            <>
                {hasOverflowLeft && (
                    <button className="desktop-menu__nav-button left">
                        <img
                            src={leftArrow}
                            alt="leftNav"
                            className="desktop-menu__nav-button__arrow"
                            onClick={scrollLeft}
                        />
                    </button>
                )}
            </>
        );
    };


    const RightButton = () => {
        return (
            <>
                {hasOverflowRight && (
                    <button className="desktop-menu__nav-button right">
                        <img
                            src={rightArrow}
                            alt="rightNav"
                            className="desktop-menu__nav-button__arrow"
                            onClick={scrollRight}
                        />
                    </button>
                )}
            </>
        );
    };

    return {
        LetfButton,
        RightButton,
    };
};

export default useNavControls;
